import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {

  const { pathname } = useLocation(); 
  const isCalendarPage = pathname === '/calendar'; 

  // Track manual collapse state
  const [isManuallyCollapsed, setIsManuallyCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebar_manually_collapsed');
    return saved ? JSON.parse(saved) : false;
  });

  // Track window width for responsive behavior
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Save manual collapse state to localStorage
  useEffect(() => {
    localStorage.setItem('sidebar_manually_collapsed', JSON.stringify(isManuallyCollapsed));
  }, [isManuallyCollapsed]);

  // AUTO-EXPAND when navigating to Calendar page
  useEffect(() => {
    if (isCalendarPage && isManuallyCollapsed) {
      setIsManuallyCollapsed(false);
    }
  }, [isCalendarPage]); // Only depend on isCalendarPage, not isManuallyCollapsed to avoid loop

  const toggleSidebar = () => {
    setIsManuallyCollapsed(prev => !prev);
  };

  // Mobile: always collapsed (no toggle). Desktop: user can toggle
  const isCollapsed = windowWidth < 768 ? true : isManuallyCollapsed;
  const isResponsivelyHidden = windowWidth < 768;

  return (
    <SidebarContext.Provider value={{ 
      isCollapsed, 
      isManuallyCollapsed,
      isResponsivelyHidden,
      toggleSidebar 
    }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};